<div class="rendition-download-container">
  <ng-container *ngIf="!successDownload">
    <p>Seleccione una modalidad de descarga</p>
    <div class="select-period-box">
      <div
        class="period-month"
        (click)="onSelectBox(0)"
        [ngClass]="{ selected: boxSelected == 0 }"
      >
        <h3>Mensual</h3>
        <div class="dropdown-box">
          <qr-dropdown
            class="month"
            [config]="dropdownMonths"
            [selected]="selectedMonth"
            (change)="dropdownChangeMonth($event)"
            [isDisabled]="boxSelected == 1"
          ></qr-dropdown>

          <qr-dropdown
            class="year"
            [config]="dropdownYears"
            [selected]="selectedYear"
            (change)="dropdownChangeYear($event)"
            [isDisabled]="boxSelected == 1"
          ></qr-dropdown>
        </div>
      </div>
      <div
        class="period-year"
        (click)="onSelectBox(1)"
        [ngClass]="{ selected: boxSelected == 1 }"
      >
        <h3>Anual</h3>
        <div class="dropdown-box">
          <qr-dropdown
            class="year"
            [config]="dropdownOnlyYears"
            [selected]="selectedOnlyYear"
            (change)="dropdownChangeOnlyYear($event)"
            [isDisabled]="boxSelected == 0"
          ></qr-dropdown>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="success-container" *ngIf="successDownload">
    <div class="icon-container">
      <qr-icon [name]="ICON_WARNING" [color]="ICON_COLOR_WHITE"></qr-icon>
    </div>
    <p>
      El archivo se procesó correctamente. Prodrá verlo en el módulo de
      descargas
    </p>
  </div>
</div>
